import Vue from 'vue';
import { mapGetters } from 'vuex';

Vue.component('raffle-component', {
  template: `<div v-on:click.stop.prevent="showRaffle()" class="c-raffle">
                <div class="c-raffle__counter">
                    <span>{{ activeView.raffle_label }}</span>
                    <div class="c-raffle__rosette">{{raffleEntries}}</div>
                </div>
            </div>`,
  computed: {
    ...mapGetters({
      activeView: 'activeView',
      raffleEntries: 'getRaffleEntries',
    }),
  },
  methods: {
    showRaffle() {
      this.$emit('notify', 'raffle');
    },
  },
});



// WEBPACK FOOTER //
// ./app/js/components/raffle-component.js